export const types = {
    Ingress: "Ingress",
    Egress: "Egress"
};

export const translate = {
    Ingress: "Ingreso",
    Egress: "Egreso"
};

export const select = Object.keys(types)
    .map(type => ({ value: type, label: translate[type] }));

export default types;